import { useEffect } from 'react';
import ScheduleChartComponent from '../../components/schedules/ScheduleChartComponent';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import { Alert } from 'antd';
import {
  ScheduleListType,
  getScheduleListAsync,
  updateScheduleAsync,
} from '../../modules/schedules';

interface ScheduleChartContainerProps {
  enterpriseId: string;
  projectId: string;
}

function ScheduleChartContainer({
  match,
}: RouteComponentProps<ScheduleChartContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const dispatch = useDispatch();
  const { data, error } = useSelector(
    (state: RootState) => state.schedules.schedules,
  );

  useEffect(() => {
    dispatch(
      getScheduleListAsync.request({
        enterpriseId,
        projectId,
        type: ScheduleListType.CHART_LIST,
      }),
    );
  }, [enterpriseId, projectId, dispatch]);

  const _updateSchedule = async (
    scheduleId: number,
    _schedule: any,
    shouldUpdateAll: boolean,
  ) => {
    // console.log('updateSchedule');
    // console.log(scheduleId);
    // console.log(_schedule);

    // await updateSchedule({
    //   enterpriseId,
    //   projectId,
    //   scheduleId: '' + scheduleId,
    //   schedule: {
    //     ..._schedule,
    //     projectId: +projectId,
    //     children: _schedule.children.map((child: any) => child.id),
    //     depends: _schedule.depends.map((child: any) => child.id),
    //   },
    // });

    dispatch(
      updateScheduleAsync.request({
        enterpriseId,
        projectId,
        scheduleId: '' + scheduleId,
        schedule: {
          ..._schedule,
          projectId: +projectId,
          children: _schedule.children.map((child: any) => child.id),
          depends: _schedule.depends.map((child: any) => child.id),
        },
      }),
    );

    // await updateSchedule({
    //   enterpriseId,
    //   projectId,
    //   scheduleId: '' + scheduleId,
    //   schedule: {
    //     ..._schedule,
    //     projectId: +projectId,
    //     children: _schedule.children.map((child: any) => child.id),
    //     depends: _schedule.depends.map((child: any) => child.id),
    //   },
    // });

    // dispatch(
    //   getScheduleDetailAsync.request({
    //     enterpriseId,
    //     projectId,
    //     scheduleId: '' + scheduleId,
    //   }),
    // );

    // dispatch(
    //   getScheduleDetailAsync.request({
    //     enterpriseId,
    //     projectId,
    //     scheduleId: '' + _schedule.parent.id,
    //   }),
    // );

    // if (shouldUpdateAll) {
    // dispatch(
    //   getScheduleListAsync.request({
    //     enterpriseId,
    //     projectId,
    //   }),
    // );
    // }
  };

  return (
    <>
      {/* {loading && <Spin />} */}
      {error && <Alert message={`${error}`} type="error" showIcon closable />}
      {data && (
        <ScheduleChartComponent
          schedules={data}
          updateSchedule={_updateSchedule}
        />
      )}
    </>
  );
}

export default ScheduleChartContainer;
